module.exports = __webpack_public_path__ + "public/SiteIcons/faceBookVerifiMenu.svg?609435b8";